<template>
  <div class="relative w-full h-full overflow-y-auto p-4">
    <div v-if="!currentContract.id" class="bg-white rounded-lg p-4">
      <span class="font-bold"
        >{{ $t('Keine Verträge vorhanden.') }}</span
      >
    </div>
    <div v-if="currentContract.id">
      <div
        class="bg-black/50 fixed top-20 left-56 right-0 h-full text-center p-10"
        v-if="editedMeal"
      >
        <div
          class="bg-white rounded-lg p-4 max-h-full overflow-y-auto inline-block relative text-left"
        >
          <div
            class="absolute top-5 right-5 p-2 cursor-pointer"
            @click="editedMeal = false"
          >
            <font-awesome-icon icon="xmark" class="text-2xl" />
          </div>
          <span class="font-bold text-xl w-full text-center"
            >{{ $t('Gericht hinzufügen') }}</span
          >
          <label>{{ $t('Hauptgericht') }}</label>
          <textarea
            class="border-2 border-gray-200 px-2 py-1 w-96"
            v-model="editableMeal"
            :placeholder="$t('Gericht')"
            @input="updateMeals()"
          ></textarea
          ><br />
          <span class="font-bold">{{ $t('Fleischart') }}</span>
          <select v-model="editableMealType" class="my-2">
            <option value="Vegetarisch">{{ $t('Vegetarisch') }}</option>
            <option value="Geflügel">{{ $t('Geflügel') }}</option>
            <option value="Fisch">{{ $t('Fisch') }}</option>
            <option value="Rind">{{ $t('Rind') }}</option>
            <option value="Schwein">{{ $t('Schwein') }}</option>
            <option value="Lamm">{{ $t('Lamm') }}</option>
          </select>
          <label>{{ $t('Variationen') }}</label>
          <input
            :placeholder="$t('Mit Vollkorn/Ohne Vollkorn')"
            class="border-2 border-gray-200 px-2 py-1 w-96"
            v-model="editableVariation"
          />
          <div class="w-full mt-2">
            <button class="full" @click="saveMeal()">{{ $t('Speichern') }}</button>
          </div>
          <div class="">
            <div
              v-for="meal in freemeals"
              @click="
                editableMeal = meal;
                updateMeals();
              "
              :key="meal"
              class="cursor-pointer border-2 border-gray-200 inline-block shadow-lg px-2 py-1 m-1"
            >
              {{ meal }}
            </div>
            <div
              v-for="meal in usedmeals"
              @click="
                editableMeal = meal;
                updateMeals();
              "
              :key="meal"
              class="cursor-pointer border-2 border-gray-200 bg-gray-500 inline-block shadow-lg px-2 py-1 m-1"
            >
              {{ meal }}
            </div>
          </div>
        </div>
      </div>
      <div class="bg-white rounded-lg py-4 px-4 w-full">
        <span class="font-bold text-xl">{{ $t('Informationen zur Essensplanung') }}</span>
        <br />
        <span
          >{{ $t('Hier können Sie die Essensplanung für Ihr Kind vornehmen.') }}</span
        >
      </div>
      <div class="bg-white rounded-lg py-4 pl-4 w-full mt-4">
        <span class="font-bold text-xl">{{ $t('Essensbestellung für Vertrag') }}</span
        ><br />
        <div
          v-for="contract in contracts"
          :key="contract.id"
          class="mr-4 shadow-lg border-4 rounded-lg my-2 px-2 pb-2 text-center inline-block align-top cursor-pointer"
          :class="{ 'border-green-500': currentContract == contract }"
          @click="selectContract(contract)"
        >
          <span class="font-bold text-lg whitespace-nowrap">{{
            contract.project
          }}</span>
          <div class="w-full text-left">
            <span><b>{{ $t('Name: ') }}</b>{{ contract.name }}</span
            ><br />
            <span><b>{{ $t('Laufzeit: ') }}</b>{{ contract.runtime }}</span>
          </div>
        </div>
        <div v-if="currentContract">
          <a
            href="https://www.ev-angel-isch.de/speiseplaene-schulmensen/"
            target="_blank"
            class="underline"
            >{{ $t('Weitere Infos und Allergene') }}</a
          >
        </div>
        <label>{{ $t('Kalenderwoche') }}</label>

        <button
          v-for="weekNr in Object.keys(availableWeeks)"
          :key="weekNr"
          class="font-bold px-2 py-1 border-gray-400 border-2 rounded-lg mr-2 mt-2 inline-block hover:border-green-200 hover:bg-transparent hover:text-black cursor-pointer text-black"
          :class="{ '!border-green-400': weekNr == selectedWeek }"
          @click="setWeek(weekNr)"
        >
          {{ $t('KW') }} {{ weekNr }} ({{ getWeekDates(weekNr) }})
        </button>
      </div>

      <div
        v-if="Object.keys(availableWeeks).length == 0"
        class="bg-white rounded-lg p-4 mt-4 font-bold inline-block w-full"
      >
        <span>{{ $t('Keine Essenspläne verfügbar') }}</span>
      </div>
      <div v-if="selectedWeek">
        <div
          class="bg-white rounded-lg py-4 px-4 w-full mt-2"
          v-if="Object.keys(selectedMealPlan).length > 0"
        >
          <span class="font-bold text-xl"
            >KW {{ selectedWeek }} ({{ getWeekDates(selectedWeek) }})</span
          >
          <div
            v-for="day in Object.keys(selectedMealPlan)"
            :key="day"
            class="border-b border-black"
          >
            <div v-if="showDayForContract(day)">
              <span class="font-bold"
                >{{ day }}, {{ getWeekDateForWeekday(selectedWeek, day) }}</span
              >
              <div v-if="selectedMealPlan[day].closed">
                <span class="inline-block ml-10 py-2 font-bold">{{ $t('geschlossen') }}:<br>{{ selectedMealPlan[day].closingReason }}</span>
                >
              </div>
              <div v-else-if="!currentContract.allergy">
                <div
                  v-for="meal in selectedMealPlan[day].meals"
                  :key="meal"
                  class="inline-block"
                >
                  <div
                    class="shadow-lg p-2 rounded-xl m-2 cursor-pointer max-w-72 inline-block border-2"
                    :class="meal.selected ? 'border-green-600' : ''"
                    v-if="meal.main != '' && (editMode || meal.selected)"
                  >
                    <div
                      class="w-full h-full flex flex-row"
                      @click="chooseMeal(day, meal)"
                    >
                      <font-awesome-icon
                        v-if="meal.protein === 'Schwein'"
                        icon="piggy-bank"
                        class="text-secondary align-top mt-2 pr-2 text-4xl"
                      />
                      <font-awesome-icon
                        v-else-if="meal.protein === 'Rind'"
                        icon="cow"
                        class="text-secondary align-top mt-2 pr-2 text-4xl"
                      />
                      <font-awesome-icon
                        v-else-if="meal.protein === 'Fisch'"
                        icon="fish-fins"
                        class="text-secondary align-top mt-2 pr-2 text-4xl"
                      />
                      <font-awesome-icon
                        v-else-if="meal.protein === 'Geflügel'"
                        icon="drumstick-bite"
                        class="text-secondary align-top mt-2 pr-2 text-4xl"
                      />
                      <img
                        src="@/assets/lamb.png"
                        v-else-if="meal.protein === 'Lamm'"
                        class="text-secondary align-top mt-1 pr-2 w-12"
                      />
                      <font-awesome-icon
                        v-else-if="meal.protein === 'Vegetarisch'"
                        icon="leaf"
                        class="text-secondary align-top mt-2 pr-2 text-4xl"
                      />
                      <font-awesome-icon
                        v-else
                        icon="utensils"
                        class="text-secondary align-top mt-2 pr-2 text-4xl"
                      />
                      <div class="inline-block">
                        <div class="border-b border-gray-700">
                          <span
                            class="font-bold"
                            @click="chooseMeal(day, meal)"
                            >{{ meal.main }}</span
                          >
                        </div>
                        <div>
                          <div v-if="meal.variations.length > 0" class="pt-2">
                            <div
                              v-for="variation in meal.variations"
                              :key="variation"
                              class="inline-block"
                            >
                              <div
                                v-if="
                                  variation.variation != '' &&
                                  (editMode || variation.selected)
                                "
                                @click="chooseVariation(meal, variation)"
                                :class="
                                  variation.selected ? 'border-green-600' : ''
                                "
                                class="font-bold px-2 py-1 m-1 border-2 bg-gray-100 rounded-lg inline-block"
                              >
                                {{ variation.variation }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <span
                  v-if="selectedMealPlan[day].meals.length == 0 || selectedMealPlan[day].meals[0].main == ''"
                  class="inline-block ml-10"
                  >Keine Gerichte auswählbar</span
                >
                <div
                  class="inline-block shadow-lg p-2 rounded-xl m-2 cursor-pointer align-top"
                  v-if="selectedMealPlan[day].desserts.length > 0"
                >
                  <font-awesome-icon
                    icon="ice-cream"
                    class="text-secondary align-top mt-2 text-4xl"
                  />
                  <div class="inline-block">
                    <div>
                      <div class="pt-2">
                        <div
                          v-for="dessert in selectedMealPlan[day].desserts"
                          :key="dessert"
                          class="inline-block"
                        >
                          <div
                            v-if="editMode || dessert.selected"
                            class="font-bold px-2 py-1 m-1 border-2 bg-gray-100 rounded-lg inline-block"
                            :class="dessert.selected ? 'border-green-500' : ''"
                            @click="chooseDessert(day, dessert)"
                          >
                            {{ dessert.dessert }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <span class="text-red-500 font-bold"
                  >Allergikeressen (automatisch ausgewählt)</span
                >
              </div>
            </div>
          </div>
          <div v-if="!currentContract.allergy" class="mt-4 w-full text-center">
            <button
              class="w-96 border-red-400 text-red-400"
              @click="editMode = true"
              v-if="isEditable(selectedWeek) && editMode == false"
            >
              {{ $t('Woche bearbeiten') }}<span v-if="isEditable(selectedWeek) == 'admin'">
                {{ $t('(nur Admin)') }}</span
              >
            </button>
            <button
              class="w-96"
              @click="saveWeek()"
              v-else-if="isEditable(selectedWeek) && editMode"
            >
              {{ $t('Woche speichern') }}
            </button>
            <span v-else class="text-red-500 font-bold"
              >{{ $t('Auswahl kann nicht mehr geändert werden.') }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
label {
  display: block;
  font-weight: bold;
}
table {
  max-width: 100%;
  border-collapse: collapse;
}

th,
td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

tr:nth-child(even) {
  background-color: #e6e6e6;
  /* Set the background color for even rows */
}
</style>
<script>
// @ is an alias to /src
import API from "@/API";
export default {
  name: "Mealplanning",
  data() {
    return {
      user: false,
      editMode: false,
      currentContract: {},
      freemeals: [],
      usedmeals: [],
      imported: {
        meals: [],
        desserts: [],
      },
      currentYear: false,
      currentWeek: false,
      project: "",
      contracts: [],
      editedDesserts: false,
      editableDesserts: "",
      editableMeal: "",
      editableMealType: "Vegetarisch",
      editableVariation: "",
      editedMeal: false,
      selectedMealPlan: {},
      selectedFile: null,
      selectedWeek: 0,
      availableWeeks: {},
      availableConfigs: {},
    };
  },

  methods: {
    chooseDessert(day, dessert) {
      if (!this.editMode) return;
      this.selectedMealPlan[day].desserts.forEach((d) => {
        d.selected = false;
      });
      dessert.selected = true;
    },
    showDayForContract(daystring) {
      if(this.currentContract[daystring] && !this.currentContract.AenderungTage){
          return true;
      }
      if(this.currentContract.AenderungTage){
        let dayOfWeek=Object.keys(this.selectedMealPlan).indexOf(daystring);
        const year =
        this.selectedWeek < this.currentWeek ? this.currentYear + 1 : this.currentYear;
      const jan1 = new Date(year, 0, 1);
      const firstDayOfWeek = (jan1.getDay() + 6) % 7; // Adjust so Monday = 0
      const daysOffset = (this.selectedWeek - 1) * 7 - firstDayOfWeek;
      const startDate = new Date(jan1);
      startDate.setDate(jan1.getDate() + daysOffset + dayOfWeek);
        
          let changeDay = new Date(this.currentContract.AenderungTage);
          console.log("Weekday")
          console.log(startDate);
          console.log("changeday")
          console.log(changeDay);
          if(changeDay >= startDate) {
            return this.currentContract[daystring];
          }else{
            return this.currentContract["Aenderung"+daystring]
          }
        }
      return false;
    },
    chooseMeal(day, meal) {
      if (!this.editMode || meal.selected) return;
      this.selectedMealPlan[day].meals.forEach((m) => {
        m.selected = false;
      });
      meal.selected = true;
      if(meal.variations.length > 0) {
        this.chooseVariation(meal, meal.variations[0]);
      }
    },
    chooseVariation(meal, variation) {
      if (!this.editMode) return;
      meal.variations.forEach((v) => {
        v.selected = false;
      });
      variation.selected = true;
    },

    getUser() {
      API.checkUser((r, status) => {
        if (status === 200) {
          this.user = r;
        }
      });
    },
    selectContract(contract) {
      this.currentContract = contract;
      let vm = this;
      this.selectedMealPlan = {};
      this.availableWeeks = {};
      for (let i = 0; i < 7; i++) {
        setTimeout(() => {
          vm.addMealplan(vm.currentWeek + i);
        }, 200 * i);
      }
    },
    setWeek(week) {
      console.log("week set");
      this.selectedWeek = week;
      this.selectedMealPlan = this.availableWeeks[week];
      this.editMode = false;
      console.log(this.selectedMealPlan);
    },
    saveWeek() {
      this.editMode = false;
      let vm = this;
      API.saveMealPlanForWeek(
        this.currentContract.id,
        this.selectedWeek < this.currentWeek
          ? this.currentYear + 1
          : this.currentYear,
        this.selectedWeek,
        this.selectedMealPlan,
        (r, status) => {
          if (status === 200) {
            vm.$emit("toast", "Woche gespeichert!");
          }
        }
      );
    },
    getWeekDates(weekNumber) {
      const year =
        weekNumber < this.currentWeek ? this.currentYear + 1 : this.currentYear;
      const jan1 = new Date(year, 0, 1);
      const firstDayOfWeek = (jan1.getDay() + 6) % 7; // Adjust so Monday = 0
      const daysOffset = (weekNumber - 1) * 7 - firstDayOfWeek;
      const startDate = new Date(jan1);
      startDate.setDate(jan1.getDate() + daysOffset);

      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 4); // Assuming work weeks of 5 days

      const startDateStr = startDate.toLocaleDateString("de-DE", {
        day: "2-digit",
        month: "2-digit",
      });
      const endDateStr = endDate.toLocaleDateString("de-DE", {
        day: "2-digit",
        month: "2-digit",
      });

      return `${startDateStr} - ${endDateStr}`;
    },
    getWeekDateForWeekday(weekNumber, weekday) {
      let year =
        weekNumber < this.currentWeek ? this.currentYear + 1 : this.currentYear;
      let startDate = new Date(
        year,
        0,
        (weekNumber - 1) * 7 - (new Date(year, 0, 0).getDay() - 1)
      );
      let offset = [
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
      ].indexOf(weekday);
      startDate.setDate(startDate.getDate() + offset);
      return startDate.toLocaleDateString("de-DE", {
        day: "2-digit",
        month: "2-digit",
      });
    },
    isEditable(weeknr) {
      let normalResult=true
      let lastOrderDateStr = this.availableConfigs[weeknr].lastOrderDate;
      // Parse as UTC and convert to local time (CET)
      let lastOrderDate = new Date(lastOrderDateStr + 'Z'); // Add 'Z' to parse as UTC
      let now = new Date();
      console.log(lastOrderDate);
      console.log(now)
      normalResult = now.getTime() < lastOrderDate.getTime();
      if(!normalResult && this.user && this.user.impersonated) return "admin";
      return normalResult;
    },
    getCurrentWeekOfYear() {
      let date = new Date();
      let dayOfWeek = date.getDay();
      let daysToAdd = dayOfWeek === 0 ? -3 : 4 - dayOfWeek; // days to add for thursday
      let thursdayOfWeek = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + daysToAdd
      );
      console.log(thursdayOfWeek);
      let firstDayOfYear = new Date(date.getFullYear(), 0, 1);
      daysToAdd =
        firstDayOfYear.getDay() === 0 ? -3 : 4 - firstDayOfYear.getDay();
      let firstThursdayOfYear = new Date(
        firstDayOfYear.getFullYear(),
        0,
        1 + daysToAdd
      );
      let days =
        Math.floor(
          (thursdayOfWeek - firstThursdayOfYear) / (24 * 60 * 60 * 1000)
        ) + 1;
      return Math.floor(days / 7) + 1;
    },
    addMealplan(weekInQuestion) {
      if (!this.currentContract.id) return;
      let vm = this;
      let wiq = weekInQuestion;
      let yiq = this.currentYear;
      if (wiq > this.getMaxISOWeek(yiq)) {
        wiq = wiq - this.getMaxISOWeek(yiq);
        yiq = yiq + 1;
      }
      API.getMealPlanForWeek(this.currentContract.id, yiq, wiq, (r, status) => {
        if (status === 200) {
          let anyMeal = false; // Ensure this is declared once
          if(!r.plan){
            return;
          }
          let days = Object.keys(r.plan);
          if (!days.includes("error")) {
            for (let i = 0; i < days.length; i++) {
              if (r.plan[days[i]].meals.length && r.plan[days[i]].meals[0].main != "") {
                anyMeal = true;
              }
            }
          }

          if (anyMeal) {
            console.log(vm.availableWeeks);
            let first = Object.keys(vm.availableWeeks).length == 0;
            vm.availableWeeks[wiq] = r.plan;
            vm.availableConfigs[wiq] = r.config;
            if (first) {
              vm.setWeek(wiq);
            }
          }
        }
      });
    },
    getContracts() {
      let vm = this;
      API.getEatingContracts((r, status) => {
        if (status === 200) {
          vm.contracts = r;
          if (vm.contracts.length > 0) {
            vm.selectContract(vm.contracts[0]);
          }
        }
      });
    },
    getMaxISOWeek(year) {
      const lastDayOfYear = new Date(year, 11, 31); // December 31st
      const dayOfWeek = lastDayOfYear.getDay() || 7; // Ensure Sunday is 7
      const lastISOWeek = Math.ceil(
        (lastDayOfYear.getDate() - dayOfWeek + 10) / 7
      );
      return lastISOWeek === 53 ? 53 : 52; // Adjust if the year ends with week 53
    },
  },
  created() {
    this.getUser();
    this.currentYear = new Date().getFullYear();
    this.currentWeek = this.getCurrentWeekOfYear();
    this.getContracts();
    window.vm = this;
  },
};
</script>